module.exports = __webpack_public_path__ + "static/media/total.777e8eb2.svg";